import { PrismaClient } from "@prisma/client";
import { enhancePrisma } from "blitz";
import applicationMiddleware from "./middlewares/application";
import paywallMiddleware from "./middlewares/paywall";
export * from "@prisma/client";
const EnhancedPrisma = enhancePrisma(PrismaClient);
const db = new EnhancedPrisma({
});
paywallMiddleware(db);
applicationMiddleware(db);
export default db;
